<template>
  <div>
    <create-vehicle-popup
      v-if="showAddModal"
      @close="showAddModal = false"
      @submitted="refreshData(); showAddModal = false;"
    />

    <b-card
      no-body
      class="mb-0"
    >

      <table-top
        show-add-button
        show-search
        @change:limit="limitChanged"
        @change:query="queryChanged"
        @click:add="showAddModal = true "
      />

      <rc-overlay :show="loading">
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="vehicles"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="loading ? $t('shared.loading') : $t('shared.no-data') "
          :sort-by.sync="query.sortBy"
          :sort-desc.sync="query.isSortDirDesc"
        >

          <!-- Column: sideNumber -->
          <template #cell(sideNumber)="data">

            <b-link
              v-if="canIEdit"
              class="text-nowrap"
              :to="{ name: 'vehicle-edit', params: { id: data.item.id } }"
            >
              {{ data.item.sideNumber }}
            </b-link>
            <span v-else>
              {{ data.item.sideNumber }}
            </span>

          </template>

          <!-- Column: registrationNumber -->
          <template #cell(registrationNumber)="data">

            <b-link
              v-if="canIEdit"
              class="text-nowrap"
              :to="{ name: 'vehicle-edit', params: { id: data.item.id } }"
            >
              {{ data.item.registrationNumber }}
            </b-link>
            <span v-else>
              {{ data.item.sideNumber }}
            </span>

          </template>

          <!-- Column: status -->
          <template #cell(status)="data">

            <div class="text-nowrap">
              {{ $t('conf.vehicle.statuses.' + data.item.status) }}
            </div>

          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">

            <div class="text-nowrap">
              <feather-icon
                v-visible-to-role="['ROLE_CONFIG_MANAGEMENT']"
                icon="EditIcon"
                class="cursor-pointer"
                size="16"
                @click="editVehicle(data.item.id)"
              />
            </div>

          </template>

        </b-table>
      </rc-overlay>

      <table-bottom
        :query="query"
        :total="total"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BLink, BTable,
} from 'bootstrap-vue'
import TableTop from '@/layouts/components/table/TableTop.vue'
import CreateVehiclePopup from '@/views/vehicles/popups/CreateVehiclePopup.vue'
import TableBottom from '@/layouts/components/table/TableBottom.vue'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'
import guard from '@/guard'
import { parseRequestError } from '@/helpers/helpers'

export default {
  components: {
    TableBottom,
    CreateVehiclePopup,
    TableTop,
    RcOverlay,

    BCard,
    BTable,
    BLink,
  },
  data() {
    return {
      showAddModal: false,
      loading: false,

      total: 0,
      query: {
        sortBy: null,
        isSortDirDesc: false,
        query: null,
        limit: 10,
        page: 1,
      },

      tableColumns: [
        {
          label: this.$t('conf.vehicle.side-number'),
          key: 'sideNumber',
          sortable: true,
        },
        {
          label: this.$t('conf.vehicle.registration-number'),
          key: 'registrationNumber',
          sortable: true,
        },
        {
          label: this.$t('conf.vehicle.status'),
          key: 'status',
          sortable: true,
        },
        {
          label: this.$t('conf.vehicle.brand'),
          key: 'brand',
          sortable: true,
        },
        {
          label: this.$t('conf.vehicle.model'),
          key: 'model',
          sortable: true,
        },
        {
          label: this.$t('shared.actions'),
          key: 'actions',
          value: null,
          class: 'actions-column',
        },
      ],
    }
  },
  computed: {
    vehicles() {
      return this.$store.getters['vehicle/getVehicles']
    },
    canIEdit() {
      return guard.hasAtLeastOneRole(this.$store.state.auth.activeUser.roles, ['ROLE_ADMIN'])
    },
  },
  watch: {
    query: {
      handler() {
        this.refreshData()
      },
      deep: true,
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    refreshData() {
      this.loading = true
      const query = {
        q: this.query.query,
        sortField: this.query.sortBy,
        sortDir: this.query.isSortDirDesc ? 'desc' : 'asc',
        limit: this.query.limit,
        page: this.query.page,
      }

      Promise.all([this.$store.dispatch('vehicle/fetchVehicles', query)])
        .then(res => {
          if (this.query.page > 1 && res[0].items.length === 0) {
            this.query.page = 1
          }
          this.total = res[0].total
          this.loading = false
        })
      // eslint-disable-next-line no-console
        .catch(err => parseRequestError(err))
    },
    editVehicle(id) {
      this.$router.push(`/vehicle/edit/${id}`)
    },
    limitChanged(newLimit) {
      this.query.limit = newLimit
    },
    queryChanged(newQuery) {
      this.query.query = newQuery
    },
  },
}
</script>

<style lang="scss">

.actions-column {
  width: 1rem;
}
</style>
